(() => {
  if (window.BelfaCollectionView) return;
  window.BelfaCollectionView = true;

  const STORAGE_KEY = 'belfa-collection-view';
  let activeView = 'grid';
  let syncScheduled = false;

  function readSavedView() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === 'list' ? 'list' : 'grid';
    } catch (error) {
      return 'grid';
    }
  }

  function saveView(view) {
    try {
      window.localStorage.setItem(STORAGE_KEY, view);
    } catch (error) {
      // A blocked localStorage should not prevent the toggle from working.
    }
  }

  function syncView() {
    document.querySelectorAll('[data-collection-product-grid]').forEach((grid) => {
      grid.dataset.view = activeView;
    });

    document.querySelectorAll('[data-collection-view-controls]').forEach((controls) => {
      controls.querySelectorAll('[data-collection-view]').forEach((button) => {
        const isActive = button.dataset.collectionView === activeView;
        button.setAttribute('aria-pressed', String(isActive));
      });
    });
  }

  function setView(view) {
    activeView = view === 'list' ? 'list' : 'grid';
    saveView(activeView);
    syncView();
  }

  function scheduleSync() {
    if (syncScheduled) return;
    syncScheduled = true;
    window.requestAnimationFrame(() => {
      syncScheduled = false;
      syncView();
    });
  }

  function init() {
    activeView = readSavedView();
    syncView();

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-collection-view]');
      if (!button) return;
      event.preventDefault();
      setView(button.dataset.collectionView);
    });

    document.addEventListener('shopify:section:load', scheduleSync);
    new MutationObserver(scheduleSync).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
